import { computed, inject } from '@angular/core';

import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';

import { ContinentSearchParams, EaContinent, EaContinentsList } from '../../models/custom-climate.model';
import { EaContinentService } from '../../services/ea-continent.service';

type EaContinentsState = {
  paginatedData: EaContinentsList;
  textSearch: string;
  currentPage: number;
  pageSize: number;
  isLoading: boolean;
};

const initialState: EaContinentsState = {
  paginatedData: { elements: [], totalElements: 0, totalPages: 0 },
  textSearch: '',
  currentPage: 1,
  pageSize: 1000,
  isLoading: false,
};

export const EaContinentsStore = signalStore(
  withState(initialState),
  withComputed(store => ({
    requestParameters: computed<ContinentSearchParams>(() => ({
      text: store.textSearch(),
      orderByField: 'NAME',
      orderByDirection: 'ASC',
      page: store.currentPage(),
      pageSize: store.pageSize(),
    })),
    continents: computed<EaContinent[]>(() => store.paginatedData().elements),
  })),
  withMethods((store, service = inject(EaContinentService)) => ({
    load: () => {
      if (store.paginatedData().elements.length > 0) return;
      patchState(store, { isLoading: true });
      service.search(store.requestParameters()).subscribe({
        next: response => patchState(store, { isLoading: false, paginatedData: response }),
        error: () => patchState(store, { isLoading: false }),
      });
    },
    reload: () => {
      patchState(store, { isLoading: true, paginatedData: { elements: [], totalElements: 0, totalPages: 0 } });
      service.search({ text: store.textSearch(), orderByField: 'NAME', orderByDirection: 'ASC', page: 1, pageSize: store.pageSize() }).subscribe({
        next: response => patchState(store, { isLoading: false, paginatedData: response }),
        error: () => patchState(store, { isLoading: false }),
      });
    },
  }))
);
